import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { AppCalendar } from "./AppCalendar";
import "./AppCalendarPage.css";
import { selectUser } from "../../../redux/features/appData";
import { CalendarItem } from "./AppCalendar";


type AppCalendarPageProps = {
}

export const AppCalendarPage = ({} : AppCalendarPageProps) => {

    const storeUser = useSelector(selectUser);

    const [calendarItems, setCalendarItems] = useState<CalendarItem[]>([]);

    useEffect(() => {
        if (!storeUser) {
            return;
        }

    }, [storeUser]);
        
    return (
         <div className="app-calendar-page">
            <h1>Company Calendar</h1>

            <AppCalendar
                items={calendarItems}
                onItemClick={(item) => {
                    console.log("Item clicked:", item);
                }}
            />

         </div>
    )
}